import React, { useState, useEffect } from "react";
import { getIdData, addData, updateData } from "../../../lib/class";
import {
  ClassForLessonSelect,
  InstructorSelect,
  SubInstructorSelect,
} from "../../ui/myselect";
import { useNavigate, useParams } from "react-router-dom";

export default function AdminClassEdit() {
  const [classname, setClassName] = useState();
  const [isActive, setIsActive] = useState(true);
  const [selectedInstructor, setSelectedInstructor] = useState();
  const [selectedSubInstructor, setSelectedSubInstructor] = useState();
  const [selectedGrade, setSelectedGrade] = useState();
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  let { slug } = useParams();

  console.log("selectedSubInstructor", selectedSubInstructor);

  async function GetData(id) {
    const classData = await getIdData(slug);
    console.log("parameterData", classData);
    setData(classData);
    setClassName(classData[0].class_name);
    setIsActive(classData[0].isActive);
    setSelectedGrade(classData[0].grade);
    setSelectedInstructor(classData[0].instructorId);
    setSelectedSubInstructor(classData[0].subinstructorId);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
      //burada SubInstructor i null set etmek icin boyle yapildi
    if (slug === "Add") {
      console.log("Add", selectedSubInstructor);
      await addData({
        class_name: classname,
        instructorId: selectedInstructor,
        grade: selectedGrade,
        isActive: isActive,
        subinstructorId: selectedSubInstructor ==='aaa' ? null : selectedSubInstructor,
      });
    } else {
      console.log("Update");
    
      await updateData({
        id: slug,
        class_name: classname,
        instructorId: selectedInstructor,
        grade: selectedGrade,
        isActive: isActive,
        subinstructorId: selectedSubInstructor ==='aaa' ? null : selectedSubInstructor,
      });
    }

    navigate("/admin/admin-class");
  };

  useEffect(() => {
    //navigate("/admin-params");
    if (slug !== "Add") {
      GetData(slug);
    }
  }, [slug]);
  return (
    <div className="col-xl-12 col-md-12">
      <div className="settings-widget profile-details">
        <div className="settings-menu p-2">
          <div className="profile-heading p-2">
            <h3>{slug === "Add" ? "Add Class" : "Update Class"}</h3>
          </div>
          <div className="checkout-form personal-address add-course-info ">
            <form role="form" onSubmit={handleSubmit}>
              <div className="row mx-auto">
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">Class Name</label>
                    <input
                      type="text"
                      value={classname}
                      onChange={(e) => setClassName(e.target.value)}
                      className="form-control"
                      placeholder="Enter Type"
                      required
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">Grade</label>
                    <ClassForLessonSelect
                      value={selectedGrade}
                      setValue={setSelectedGrade}
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <InstructorSelect
                      value={selectedInstructor}
                      setValue={setSelectedInstructor}
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <SubInstructorSelect
                      value={selectedSubInstructor}
                      setValue={setSelectedSubInstructor}
                      excludeInstructor={selectedInstructor}
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">Is Active</label>
                    <div className="form-check form-switch check-on">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={isActive}
                        onChange={(e) => setIsActive(!isActive)}
                      />
                    </div>
                  </div>
                </div>
                <div className="update-profile d-flex justify-content-between">
                  <button type="submit" className="btn btn-primary">
                    {slug === "Add" ? "Add Class" : "Update Class"}
                  </button>
                  <button
                    onClick={() => navigate(-1)}
                    className="btn btn-black btn-sm"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
